<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-select class="full-width" clearable v-model="valueSync" filterable :placeholder="placeholder"
               :disabled="disabled">
        <el-option
                v-for="item in options"
                :disabled="item.id === filter"
                :key="item.id"
                :label="item.name"
                :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: '',
        props: {
            value: String | Number,
            placeholder: String,
            disabled: Boolean,
            filter: String | Number
        },
        computed: {
            options () {
                const competitions = this.$store.state.competition.mainCompetitions;
                if (competitions === null) {
                    this.$store.dispatch('competition/loadMainCompetitions').then();
                    return [];
                }
                return competitions;
            }
        },
        data () {
            return {
                valueSync: null
            };
        },
        watch: {
            value (value) {
                this.valueSync = value;
            },
            valueSync (valueSync) {
                if (valueSync === '') {
                    this.valueSync = null;
                    return;
                }
                this.$emit('input', valueSync);
            }
        }
    };
</script>
